<template>
  <el-dialog
    title=""
    :visible.sync="$store.state.warning.warningFalg"
    width="60%"
    :append-to-body="true"
    center>
      <p class="wrap">{{$store.state.warning.warningMsg}}</p>

      <span slot="footer" class="dialog-footer">
        <slot @click.stop="cancel"></slot>
      </span>
  </el-dialog>
</template>
<script>
import axios from "axios"

import config from "../../config";
import { Loading } from 'element-ui'
// import { delete } from 'vue/types/umd';
export default {
  name: "warningDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      canRefresh:true
    };
  },
  methods: {
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    async refreshEvet() {
      var that = this;
      let obj = this.getAuthObj();
      obj.refreshKey = this.$store.state.userInfo.refreshKey
      obj.apiUrl = this.apiConfig.refreshToken;
      let data = await this.$store.dispatch("apiEvent", obj);
      that.canRefresh = true;
      if (!data) return;
      this.$store.state.userInfo.expiredTime = data.data.result.expiredTime;
      this.$store.state.userInfo.refreshKey = data.data.result.refreshKey;
      this.$store.state.userInfo.token = data.data.result.token;
      sessionStorage.setItem(
        "userInfo",
        JSON.stringify(this.$store.state.userInfo)
      );
    }
  },
  mounted: function() {
    var that = this;
    this.$router.beforeEach((to, from, next) => {

      if (to.meta.title) {
        that.$store.commit("setPageTitle", to.meta.title)
        document.title = 'JPC cms | '+that.$store.state.pageTitle
      }
      if(that.$store.state.edit&&to.path!='/'){
        that.$store.commit("setwarning", {
          string: that.$i18n.t("message.leaveTip"),
          boolean: true,
          button: [{
              name:'Stay',
              callBack:function(){
                that.$store.commit("setwarning", { string: "", boolean: false });
              }
            }, {
              name:'Leave',
              callBack:function(){
                
                that.$store.commit("setwarning", { string: "", boolean: false });
                next();
              }
            }]
        });
      }else{
        next();
      }
    })
    this.$router.afterEach((to, from, next) => {
      $('.spiner-postion').addClass('hide');
      that.$store.state.edit = false;
    })

    var loadingInstance;
    
    axios.interceptors.request.use(function (config) {
      const isNotShowLoading= config.headers.isNotShowLoading
      var thisTime = new Date().getTime();
      var expiredTime = that.$store.state.userInfo.expiredTime
      if((expiredTime-thisTime)<40*60*1000&&expiredTime>thisTime&&that.canRefresh){
        that.canRefresh = false;
        // that.refreshEvet();
      }
      if(!isNotShowLoading){
        loadingInstance = Loading.service({ fullscreen: true })
      }else{
        delete config.headers.isNotShowLoading
      }

      return config;
    }, function (error) {
      
      loadingInstance.close();
      that.$store.getters.warning.warningMsg = error.message;
      that.$store.getters.warning.warningFalg = true;
      that.$store.getters.warning.button = [{
                  name:"Cancel",
                  callBack:function(){that.$store.getters.warning.warningFalg = false;}
                }];
      return Promise.reject(error);
    })
    //获取response error
    axios.interceptors.response.use(function (response) {
      loadingInstance.close();
      return response;
    }, function (error) {
      loadingInstance.close();

      try {
        if(error.response.status==500){
          that.$store.getters.warning.warningMsg = error.response.data.message;
        }else{
          that.$store.getters.warning.warningMsg = error.message;
        }
      } catch (err) {
        that.$store.getters.warning.warningMsg = "Network Error!";
      }
      that.$store.getters.warning.warningFalg = true;
      that.$store.getters.warning.button = [{
                  name:"Cancel",
                  callBack:function(){that.$store.getters.warning.warningFalg = false;}
                }];
      return Promise.reject(error);
    })
  }
};
</script>
